module.exports = "/assets/data/28f683f81671a4a3bf1cd44b56e0dce3-BT42.data.json";